import { Button, Dialog } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ReleaseParty } from '../../../global/adapters/crpAPI';
import ReleasePartyModal from './ReleasePartyModal';
import useStyles from './styles';

type Props = {
  selectedUserType: any;
  selectedNewRelease: any;
  setSelectedReleaseParty: React.Dispatch<React.SetStateAction<ReleaseParty | undefined>>;
  selectedReleaseParty: ReleaseParty | undefined;
  selectedIdentification: { type: string; value: string } | undefined;
  setSelectedIdentification: React.Dispatch<
    React.SetStateAction<
      | {
          type: string;
          value: string;
        }
      | undefined
    >
  >;
};

const UpdateStep = ({
  selectedUserType,
  selectedNewRelease,
  setSelectedReleaseParty,
  selectedReleaseParty,
  selectedIdentification,
  setSelectedIdentification,
}: Props) => {
  const { t } = useTranslation(['common', 'transferReleaseRight']);
  const { classes } = useStyles();

  const [modalOpen, setModalOpen] = React.useState(false);

  return (
    <React.Fragment>
      <Button
        color="inherit"
        variant="outlined"
        size="large"
        endIcon={<ArrowDropDownIcon />}
        onClick={() => setModalOpen(true)}
      >
        {t('transferReleaseRight:actions.selectReleaseParty')}
      </Button>
      <Dialog open={modalOpen} className={classes.dialog} maxWidth="lg">
        <ReleasePartyModal
          selectedUserType={selectedUserType}
          selectedReleaseParty={selectedReleaseParty}
          setSelectedReleaseParty={setSelectedReleaseParty}
          selectedIdentification={selectedIdentification}
          setSelectedIdentification={setSelectedIdentification}
          setModalOpen={setModalOpen}
          selectedNewRelease={selectedNewRelease}
        />
      </Dialog>
      <div>
        {t('transferReleaseRight:selectParty.haveSelected')}
        {selectedNewRelease?.nxtEntityId
          ? selectedNewRelease?.nxtEntityId
          : selectedNewRelease?.value ?? t('transferReleaseRight:selectParty.nothingYet')}
        {selectedNewRelease && t('transferReleaseRight:selectParty.asNewParty')}
      </div>
    </React.Fragment>
  );
};

export default UpdateStep;
